import { AxiosInstance } from 'axios'
import { MediaObject, MediaObjectList } from '@/shared/api/strapi/requests/types'
import { BlocksContent } from '@strapi/blocks-react-renderer'

export interface GetAboutArgs {
  locale: string
}

interface StrapiData<T> {
  id: number
  attributes: T
}

interface FeatureComponent {
  id: number
  title: string
  text: BlocksContent
  image: MediaObject
}

interface HomePageAttributes {
  our_history_title: string
  excellence_in_every_detail_title: string
  excellence_in_every_detail_text: BlocksContent
  key_facts_title: string
  key_facts_text: BlocksContent
  our_3_top_features_title: string
  discover_more_button_text: string
  health_and_beauty_title: string
  health_and_beauty_text: BlocksContent
  our_press_title: string
  our_awards_title: string
  job_inquiries_title: string
  our_clients_title: string
  celebrities_title: string
  createdAt: string
  updatedAt: string
  locale: string
  transformation_stories_button_text: string
  celebrities_button_text: string
  main_image: MediaObject
  four_photos: MediaObjectList
  features: FeatureComponent[]
  transformation_stories: {
    data: unknown[]
  }
  health_and_beauty_image: MediaObject
  awards: unknown[]
}

export interface AboutPageDto {
  data: StrapiData<HomePageAttributes>
  meta: Record<string, never>
}

export const getAbout = async (
  client: AxiosInstance,
  { locale }: GetAboutArgs,
): Promise<AboutPageDto['data']['attributes']> => {
  const path = `/about-page-block`
  const params = {
    locale,
    sort: { createdAt: 'desc' },
    populate: {
      fields: ['*'],
      main_image: { fields: ['url', 'alternativeText', 'caption'] },
      excellence_in_every_detail_text: { populate: '*' },
      four_photos: {
        fields: ['id', 'url', 'alternativeText', 'caption'],
      },
      features: { populate: '*' },
      transformation_stories: { populate: '*' },
      health_and_beauty_text: { populate: '*' },
      health_and_beauty_image: { fields: ['url', 'alternativeText', 'caption'] },
      awards: { populate: '*' },
    },
  }
  return (await client.get<AboutPageDto>(path, { params })).data.data.attributes
}
